import { useState } from "react";
import { NXEyes } from "../../icons";
import GenericSelectableTable from "../selectableTable";
import CartDetailsView from  "./cartDetailViews";
import moment from "moment";


interface StockTableProps {
    data: any;
    refresh: ()=>void;
}

function AbandonedCartTable({data, refresh}:StockTableProps) {
  const [stockDetailOpen, setStockDetailOpen] = useState(null);

  const columns = [
    { header: "ID", key: "node.dbId", render:(item:any)=>(
      <div className="text-base-300 text-sm">
        #ID {item.node.dbId}
      </div>
    )},
    { header: "Customer", key: "node.user.fullName", },
    { header: "Total Item", key: "node.totalItems", },

    { header: "Abandoned At", key: "node.abandonedAt", render: (item: any) => (
        <div className="text-base-300 text-sm">
            {moment(item.node.abandonedAt).fromNow()}
        </div>
    )},


    { header: "Actions", key: "actions", render: (item: any) => (
        <div className="flex gap-2">
            <button className="p-1" onClick={() => setStockDetailOpen(item.node.user.dbId)}>
             <NXEyes className="text-primary-400" />
            </button>
        </div>
    )},

  ]

  return (
    <div>
      <div className="overflow-x-auto">
        <GenericSelectableTable columns={columns} data={data}/>
      </div>
      {stockDetailOpen &&  <CartDetailsView instance={stockDetailOpen} isOpen={stockDetailOpen ? true : false} onClose={()=>setStockDetailOpen(null)} refresh={refresh} /> }
    </div>
  )
}

export default AbandonedCartTable